import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Text } from '../text/index.js';
import { visuallyHiddenStyles } from '../../utils/styleHelpers.js';
import { SPINNER_SIZES } from './constants.js';
export { SPINNER_SIZES } from './constants.js';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
const spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
const wrapperCoverStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  background: rgba(255, 255, 255, 0.5);\n  cursor: wait;\n"])), _ref => {
  let {
    fixed
  } = _ref;
  return fixed ? 'fixed' : 'absolute';
}, _ref2 => {
  let {
    fixed
  } = _ref2;
  return fixed ? 1000 : 100;
});
const spinnerCoverStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n"])));
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "spinner__Wrapper",
  componentId: "sc-10at1tq-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  ", ";\n\n  &:focus {\n    box-shadow: none;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.primary.main;
}, _ref4 => {
  let {
    cover,
    fixed
  } = _ref4;
  return (cover || fixed) && wrapperCoverStyles;
});
const StyledSpinner = /*#__PURE__*/styled.div.withConfig({
  displayName: "spinner__StyledSpinner",
  componentId: "sc-10at1tq-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  align-self: center;\n  border: ", ";\n  border-bottom-color: ", ";\n  border-left-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  animation: ", " ", ";\n  cursor: wait;\n  ", ";\n\n  ", "\n"])), _ref5 => {
  let {
    thickness
  } = _ref5;
  return "".concat(thickness, " solid currentColor");
}, _ref6 => {
  let {
    emptyColor
  } = _ref6;
  return "".concat(emptyColor);
}, _ref7 => {
  let {
    emptyColor
  } = _ref7;
  return "".concat(emptyColor);
}, _ref8 => {
  let {
    color
  } = _ref8;
  return "".concat(color);
}, spin, _ref9 => {
  let {
    speed
  } = _ref9;
  return "".concat(speed, " linear infinite");
}, _ref10 => {
  let {
    cover,
    fixed
  } = _ref10;
  return (cover || fixed) && spinnerCoverStyles;
}, _ref11 => {
  let {
    size
  } = _ref11;
  switch (size) {
    case SPINNER_SIZES.SMALL:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          width: 1.5rem;\n          height: 1.5rem;\n        "])));
      }
    case SPINNER_SIZES.MEDIUM:
      {
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          width: 2.25rem;\n          height: 2.25rem;\n        "])));
      }
    case SPINNER_SIZES.LARGE:
      {
        return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          width: 3.5rem;\n          height: 3.5rem;\n        "])));
      }
    // no default
  }
});

const Label = /*#__PURE__*/styled(Text).withConfig({
  displayName: "spinner__Label",
  componentId: "sc-10at1tq-2"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), visuallyHiddenStyles);
const Spinner = /*#__PURE__*/forwardRef(function Spinner(_ref12, ref) {
  let {
    color = 'currentColor',
    cover,
    emptyColor = 'transparent',
    fixed,
    label,
    size = SPINNER_SIZES.MEDIUM,
    speed = '0.75s',
    thickness = '2px',
    ...rest
  } = _ref12;
  return /*#__PURE__*/jsx(Wrapper, {
    "aria-live": "assertive",
    cover: cover,
    fixed: fixed,
    ref: ref,
    role: "status",
    tabIndex: "0",
    ...rest,
    children: /*#__PURE__*/jsx(StyledSpinner, {
      color: color,
      cover: cover,
      emptyColor: emptyColor,
      fixed: fixed,
      size: size,
      speed: speed,
      thickness: thickness,
      children: /*#__PURE__*/jsx(Label, {
        as: "span",
        children: label
      })
    })
  });
});

export { Spinner };
